// extracted by mini-css-extract-plugin
export default {"bread":"Breadcrumbs_bread__9oPa3","root":"Breadcrumbs_root__xpTpp"};